"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertPriceToCurrencyRoundedUp = convertPriceToCurrencyRoundedUp;
/*
 * Converts price to a different currency using the given exchange rate.
 * Round up to the nearest integer.
 */
function convertPriceToCurrencyRoundedUp(price, exchangeRate) {
    return Math.ceil(price * exchangeRate);
}
//# sourceMappingURL=convert-price-to-currency-rounded-up.js.map